import React from 'react';
import '../Challenges/Challenges.css';

import { firestore } from '../../firebaseConfig';
import {PremiumContent} from "../../models/PremiumContent";
import PremiumContentPlayer from "./PremiumContentPlayer";
import {
    IonCard,
    IonSlide,
    IonSlides,
    IonCardContent,
    IonButton,
    IonRow,
    IonIcon,
    IonImg,
    IonRouterLink,
    IonItem,
    IonToolbar,
    IonGrid,
    IonButtons, IonSegment, IonSegmentButton, IonLabel, IonContent, IonText, IonCol, IonNote, IonCardHeader, IonThumbnail
} from "@ionic/react";
import './Sliders.css';
import {star} from "ionicons/icons";
import UserAvatar from "../../components/UserAvatar";
import UserDetails from "../../components/UserDetails";
import ContentPlayer from "../../components/Player/ContentPlayer";
import ProfileCallVideo from './Universe/ProfileCallVideo';
import {downloadPictureContent, viewProfileAssociation } from '../../util/avatarUtils';
import MissionDeliveryComponent from '../../components/MissionDeliveryComponent';
import ChallengePromptModule from '../Challenges/ChallengePromptModule';
import { withRouter } from 'react-router';
import authWrapper from '../../components/authWrapper';

interface SeriesContentFeedState {
    seriesContentList: PremiumContent[],
    activeIdx: string,
    user: any,
}


class SeriesContentFeed extends React.Component<{},SeriesContentFeedState>  {

    constructor(props) {
        super(props);

        this.state = {
            seriesContentList: [],
            activeIdx: null,
            user: props.user,
        };
    }

    componentDidMount() {

        firestore.collection('premiumContent').where('contentType','==','series').orderBy('date','asc')
            .onSnapshot(snapshot => {
                let seriesContentList = [];
                snapshot.forEach(doc =>
                    seriesContentList.push({ ...doc.data(), uid: doc.id }),
                );

                this.setState({
                    seriesContentList,
                });
            });

    }


    render() {

        const { seriesContentList, activeIdx, user } = this.state;

        const slideOpts = {
            effect: 'cube',
            zoom: false
        };

        const showHideUniverse = (idx) => {
            let universeContentContainer = document.getElementById('universeContent'+idx);
            let universeCardHeaderContainer = document.getElementById('universeCardHeader'+idx);

            let universeCardContentContainer = document.getElementById('universeCardContent'+idx);
            if (!universeContentContainer) return

            if (universeContentContainer.style.display === 'block') {
                universeContentContainer.style.display='none';
                universeCardContentContainer.style.display='none';
                universeCardHeaderContainer.style.display='none';
           //     segmentContentContachatiner.style.display='none';
                this.setState({activeIdx: null})
            }
            else {
                universeContentContainer.style.display='block';
                universeCardContentContainer.style.display='block';
                universeCardHeaderContainer.style.display='block';
            //    segmentContentContainer.style.display='block';
                this.setState({activeIdx: idx})
            }
        }

        function changeSegmentContent(selectedSegment, idx) {
            let castFeedContainer = document.getElementById('castFeed'+idx);
            let ctaFeedContainer = document.getElementById('ctaFeed'+idx);
            let ugcFeedContainer = document.getElementById('ugcFeed'+idx);

            if (selectedSegment === ('cast'+idx)) {
                castFeedContainer.style.display='block';
                ctaFeedContainer.style.display = 'none';
                ugcFeedContainer.style.display='none';

            } else if (selectedSegment === ('cta'+idx)) {
                ctaFeedContainer.style.display = 'block';
                castFeedContainer.style.display = 'none';
                ugcFeedContainer.style.display='none';
            }
            else if (selectedSegment === ('ugc'+idx)) {
                ugcFeedContainer.style.display='block';
                ctaFeedContainer.style.display = 'none';
                castFeedContainer.style.display='none';
            }
        }

        let completeProfile = () => {
            window.location.href='/profile';
        }

        let missionBackup = {code: 'HB', title: 'Hero Backup', uid: 'uFPkuZHelTiTHmSfBL5Y',
            clientName: 'Justice F. Hire',
            posterUrl: 'Missions/thumbnails/Mission-Hero-Backup-CTA-thumbnail.jpg',
            contentUrl: 'Missions/content/Mission-Hero-Backup-CTA.MOV',
            completedBy: [''],
            description: 'Join another hero to help on their mission.',
            direction: ['Back another hero up on either an original mission or an existing JFH mission.', 'Keep your camera beside the hero you are backing up. Make sure to keep them, yourself, and the action in the shot. '],
            ctaVideoUrl: 'Missions/content/Mission-Hero-Backup-CTA.MOV',
            contentType: 'video/quicktime',
            submittedBy: '',
        };


        return (
            <IonSlides pager options={slideOpts} onIonSlideDidChange={() => showHideUniverse(activeIdx)}>

                {seriesContentList && seriesContentList.map((contentItem, idx) => {
                    return (
                        <IonSlide key={idx}>
                        <IonCard className='widthFullCard'>
                                <PremiumContentPlayer key={idx} item={contentItem}/>
                                <IonGrid style={{'background':'#005494'}}>
                                        <IonButton id={'universeBtn'+idx} className="universeBtn italic" onClick={() => showHideUniverse(idx)}> UNIVERSE
                                            <IonIcon slot="end" src={"assets/img/universe.svg"} />
                                        </IonButton>

                                        <IonCard id={'universeContent'+idx}  style={{'background':'#ffffff', 'display':'none', 'margin':'0'}}>
                                            <IonCardHeader id={'universeCardHeader'+idx} style={{'display':'none'}}>
                                            <IonRow className="ion-text-justify">
                                                <IonText style={{ 'color':'#005494'}} className="bolder">{contentItem.title}</IonText>
                                            </IonRow>
                                            <IonRow className="ion-text-justify" style={{ 'marginBottom':'4px'}}>
                                                <IonText style={{ 'color':'#005494'}}>{contentItem.description}</IonText>
                                            </IonRow>
                                            </IonCardHeader>
                                            <IonCardContent id={'universeCardContent'+idx} style={{'display':'none'}}>
                                            <IonSegment value={'cast'+idx} onIonChange={(e) => changeSegmentContent(e.detail.value as any, idx)}>
                                                <IonSegmentButton value={'cast'+idx}>
                                                    <IonLabel className="labelText">Cast</IonLabel>
                                                </IonSegmentButton>
                                                <IonSegmentButton value={'cta'+idx}>
                                                    <IonLabel className="labelText">Prompts</IonLabel>
                                                </IonSegmentButton>
                                                <IonSegmentButton value={'ugc'+idx}>
                                                    <IonLabel className="labelText">Content</IonLabel>
                                                </IonSegmentButton>
                                            </IonSegment>
                                            <div id={'castFeed'+idx} className="ion-text-justify">
                                                <IonRow className="ion-text-justify">
                                                    <IonCol>
                                                        <IonText style={{ 'color':'#005494'}} className="bolder">
                                                            Appearing in this episode
                                                        </IonText>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol size="6"><IonLabel className="brandText bolder">In-Character</IonLabel></IonCol>
                                                    <IonCol><IonLabel className="brandText bolder">Out-Of-Character</IonLabel></IonCol>
                                                </IonRow>
                                                <IonRow>
                                                    <IonText style={{'color':'#005494'}}>
                                                        {contentItem.cast && contentItem.cast.map((castMember, castIdx) =>{
                                                         return(
                                                          <UserDetails key={castIdx} userPhotoURL={castMember?.photoURL} userId={castMember.castId} userHeroName={castMember.castName} userRole={castMember.castRole} userRealName={castMember.castRealName} showMoreInfo={true} tab={'seriesCast'} index={castIdx}/>
                                                          )
                                                        })}
                                                    </IonText>
                                                </IonRow>
                                                <IonRow>
                                                    <IonNote style={{'color':'#005494', 'fontSize':'5px'}}>Characters are portrayed by and are copyrights © of their respective owners, used with permission under the non-exclusive license granted by the <IonRouterLink href="/pages/TermsPage"><span className={"italic bolder"}>Terms of Service</span></IonRouterLink>.</IonNote>
                                                </IonRow>
                                            </div>
                                            <div id={'ctaFeed'+idx} style={{'display':'none'}} className="ion-text-justify">
                                                <IonRow className="ion-text-justify">

                                                        <IonText style={{ 'color':'#005494'}} >
                                                            <span className="bolder">Calls To Action</span> completed in this episode
                                                        </IonText>

                                                </IonRow>
                                               <ProfileCallVideo tab={'series'}/>
                                                <IonGrid>
                                                    <IonRow style={{'float':'right'}}>
                                                        <IonButton onClick={completeProfile} shape="round" fill="solid" style={{ '--background': '#66cc33', '--color':'#ffffff','height':'25px'}} className="btn-complete-mission">COMPLETE PROFILE</IonButton>
                                                    </IonRow>
                                                    <IonRow><IonCol></IonCol></IonRow>
                                                    <IonRow><IonCol></IonCol></IonRow>
                                                    <IonRow><IonCol></IonCol></IonRow>
                                                </IonGrid>
                                                {
                                                    idx===3 &&
                                                        <>
                                                            <ChallengePromptModule challengeId={'W5mg9sY0dpIDtt5WFsXI'} showButtons={true} user={user}/>
                                                            <IonRow><IonCol></IonCol></IonRow>
                                                            <IonRow><IonCol></IonCol></IonRow>
                                                        </>
                                                }

                                                <IonRow className="ion-text-justify">
                                                    <IonText style={{'color':'#005494', 'fontSize':'10px'}}> Episode closed for submission. <span className={" bolder"}>Check in Production section to contribute to an upcoming episode.</span></IonText>
                                                </IonRow>
                                            </div>
                                            <div id={'ugcFeed'+idx} style={{'display':'none'}} className="ion-text-justify">
                                                <IonRow className="ion-text-justify">
                                                    <IonCol>
                                                        <IonText style={{ 'color':'#005494'}} >
                                                           <span className="bolder">Content selected </span> for this episode
                                                        </IonText>
                                                    </IonCol>
                                                </IonRow>
                                                        {contentItem.content && contentItem.content.map((userContentDetails, userContentIdx) =>{
                                                            return(

                                                                <IonCard className="child4" key={userContentIdx}>
                                                                    <IonThumbnail style={{'height':'80%', 'width':'100%'}}>
                                                                        <IonImg id={'userContent'+idx+userContentDetails.castId} src={userContentDetails.castPhotoURL ? downloadPictureContent(userContentDetails.castPhotoURL,userContentDetails.castId, 'userContent'+`${idx}`) : "https://www.gravatar.com/avatar?d=mm"}
                                                                                onClick={() => viewProfileAssociation(userContentDetails.castId)}/>
                                                                    </IonThumbnail>
                                                                    <IonText className="brandText bolder" style={{'fontSize':'7px'}}>
                                                                        {userContentDetails.castName}

                                                                    </IonText>
                                                                </IonCard>
                                                            )
                                                        })}


                                            </div>
                                            </IonCardContent>
                                        </IonCard>
                                </IonGrid>
                        </IonCard>

                        </IonSlide>
                    )
                })}
            </IonSlides>
        );
    };
}
export default authWrapper(SeriesContentFeed);
